import React from 'react';
import styled from 'styled-components';
import EditIcon from '../../images/edit_icon.png';

const SingleTagItem = ({ onEditTag, tagId, name, can_delete, isCanEdit, onDeleteTag }) => {
  return (
    <Item>
      <ItemTitle>{name}</ItemTitle>
      {isCanEdit && (
        <EditButton onClick={onEditTag} right={!can_delete ? '10px' : '50px'}>
          <Img src={EditIcon} alt="edit" />
        </EditButton>
      )}
      {can_delete && <DeleteButton onClick={() => onDeleteTag(tagId, name)}>X</DeleteButton>}
    </Item>
  );
};

export default SingleTagItem;

const Item = styled.div`
  width: 30%;
  position: relative;
  padding: 15px 90px 15px 10px;
  margin: 5px 0;
  box-sizing: border-box;
  border: 1px solid #c1c1c1;
  border-radius: 3px;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  @media (max-width: 1000px) {
    width: 40%;
  }
  @media (max-width: 720px) {
    width: 80%;
    margin: 0 auto;
  }
`;

const ItemTitle = styled.p`
  font-size: 14px;
  margin: 0;
`;

const DeleteButton = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  background: #db2828;
  color: #fff;
  border: none;
  border-radius: 5px;
  &:hover {
    background: #d01919;
    border: 1px solid #000542;
  }
`;

const EditButton = DeleteButton.extend`
  right: ${(props) => props.right};
  border: 1px solid #000542;
  background: #fff;
  &:hover {
    background: #17ade3;
  }
`;

const Img = styled.img`
  width: 20px;
  height: 20px;
`;



// WEBPACK FOOTER //
// ./src/Components/Tags/SingleTagItem.jsx